export enum NotificationFeedEnum {
  COMMENTS = "comments",
  LIKES = "likes",
  FOLLOWS = "follows",
}
